// src/components/Toast.js
import React, { useEffect, useState } from 'react';

const Toast = ({ id, message, type = 'info', onClose, duration = 3000 }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const hideTimer = setTimeout(() => {
      setVisible(false);
      setTimeout(() => onClose(id), 300); // Give time for exit animation
    }, duration);

    return () => {
      clearTimeout(hideTimer);
    };
  }, [id, onClose, duration]);

  // --- START OF CHANGES ---
  let borderColorClass = 'border-gray-500'; // Default border color
  let textColorClass = 'text-gray-800';    // Default text color
  let icon = '💡';
  let progressBgColorClass = 'bg-gray-400'; // Default progress bar color

  switch (type) {
    case 'success':
      borderColorClass = 'border-green-500';
      textColorClass = 'text-green-700'; // Text in a darker green
      icon = '✅';
      progressBgColorClass = 'bg-green-500'; // Progress bar matches border/text color
      break;
    case 'error':
      borderColorClass = 'border-red-500';
      textColorClass = 'text-red-700'; // Text in a darker red
      icon = '❌';
      progressBgColorClass = 'bg-red-500';
      break;
    case 'warning':
      borderColorClass = 'border-yellow-500';
      textColorClass = 'text-yellow-700'; // Text in a darker yellow/orange for readability
      icon = '⚠️';
      progressBgColorClass = 'bg-yellow-500';
      break;
    case 'info':
    default:
      borderColorClass = 'border-blue-500';
      textColorClass = 'text-blue-700'; // Text in a darker blue
      icon = 'ℹ️';
      progressBgColorClass = 'bg-blue-500';
      break;
  }
  // --- END OF CHANGES ---

  return (
    <div
      className={`
        relative p-4 rounded-lg shadow-lg mb-3 flex flex-col overflow-hidden
        bg-white border-l-4 ${borderColorClass} // Main toast background is white, border on left
        ${textColorClass} // Apply dynamic text color
        transition-all duration-300 ease-in-out
        ${visible ? 'translate-x-0 opacity-100' : 'translate-x-full opacity-0'}
      `}
      role="alert"
    >
      {/* Progress Bar */}
      <div
        className={`absolute top-0 left-0 h-1 ${progressBgColorClass} rounded-full`}
        style={{
          width: '100%',
          animation: `progress-bar-shrink ${duration / 1000}s linear forwards`,
        }}
      ></div>

      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <span className="mr-2 text-xl">{icon}</span> {/* Increased icon size */}
          <span>{message}</span>
        </div>
        <button
          onClick={() => {
            setVisible(false);
            if (onClose) {
              setTimeout(() => onClose(id), 300);
            }
          }}
          className={`ml-4 ${textColorClass} text-lg font-bold`} // Close button text color
          aria-label="Close"
        >
          &times;
        </button>
      </div>

      {/* Tailwind's JIT mode might not pick up dynamic keyframes, so add them directly */}
      <style jsx>{`
        @keyframes progress-bar-shrink {
          from {
            width: 100%;
          }
          to {
            width: 0%;
          }
        }
      `}</style>
    </div>
  );
};

export default Toast;